module.exports = "/static/media/identification_icon.ac56e89c.svg";